<script>
  export let image;
  export let title;
  export let content;
  export let videoUrl;
  export let gallery;
  export let handleVideoLoad;

  import CloseButton from './CloseButton.svelte';
  import PopupGallery from './PopupGallery.svelte';
  import { fly, fade } from 'svelte/transition';


  function openGallery(){
    console.log('opening gallery');
    console.log(gallery);

    new PopupGallery({ 
      target: document.getElementById('popup-gallery'), 
      props: { gallery: gallery, close: closePopup },
    })
  }``

  let visible = true;
  function closePopup() {
    visible = false;
  }
</script>

<style>
.popup {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  height: 100%;
}

.column {
  display: flex;
  flex-direction: column;
  flex-basis: 100%;
  flex: 1;
  height: 100%;
}

.image {
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
}

.title {
  margin: 2rem 0;
  margin-bottom: 0;
  font-family: 'Oswald', sans-serif;
  font-size: 2rem;
  line-height: 1;
}

.content {
  justify-content: center;
  font-family: 'Raleway', sans-serif;
  line-height: 1.5;
}

.content-inner {
  padding: 2rem;
  padding-top: 0;
  overflow-y: scroll;
}

.items {
  position: absolute;
  width: 100%;
  bottom:0;
  left: 0;
  right: 0;
  box-sizing: border-box;

  display: flex;
  flex-direction: row;
  flex-wrap: wrap;  
  padding: 5%;
  justify-content: center;
}

.item {
  cursor: pointer;
  background: rgba(var(--theme-color-rgb), 0.85);
  border-radius: 5px;
  margin: 5px;
  padding: 0.5rem 2rem;
  font-size: 1.5rem;
  display: flex;
  flex-direction: row;
  flex-basis: 100%;
  flex: 0;
  height: 100%;
  font-family: 'Oswald', sans-serif;
  font-weight: 300;
  box-shadow: 1px 2px 2px #00000040;
}

.item img {
  width: 1em;
  height: 1em;
  margin: auto 0.25em;
}

:global(.popup .content-inner a){
    color: #fff;
    font-weight: 700;
}

::-webkit-scrollbar {
 width: 6px;
}
::-webkit-scrollbar-thumb {
 background: #fff;
}

::-webkit-scrollbar-thumb:hover{
    background: #ddd;
}

.popup-area {
  position: fixed;
  z-index: 2001;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100vw;
  height: 100vh;
}

.popup-bg {
  position: fixed;
  z-index: 2000;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.66);
}


.popup-window {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99999;
  max-width: 75%;
  max-height: 100%;
}

.popup-window-wrap {
  position: relative;
  margin: 2rem;
  max-height: 100%;
  box-sizing: border-box;
}

.popup-window {
  position: relative;
  width: 40rem;
  max-width: 100%;
  max-height: 100%;
  margin: 2rem auto;
  color: black;
  border-radius: 10px;
  background: var(--theme-color);
  color: rgb(255, 255, 255);
  width: 50%;
  overflow: hidden;
}

.popup-modal.has-image .popup-window {
  padding-bottom: 45%;
  width: 90%;
}

.popup-content {
  border-radius: 5px;
    padding: 0;
    height: 100%;
    width: 100%;
}

.popup-modal.has-image .popup-content {
  position: absolute;
}

.content-inner .items {
  position: static;
  padding: 0;
  
}
.content-inner .item {
  background: #fff;
  color: #000;
}

.content-inner .item img {
  filter: invert(1);

}

@media only screen and (max-width: 600px) {  
  .popup-area {
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    
    width: 90%;
    height: 90%;
  }


  .popup-window-wrap, .popup-window {
    width: 100% !important;
    height: 100% !important;
    margin: 0 !important;
    padding: 0 !important;
  }

  .popup-window {
    border-radius: none;
  }

  .column {
    height: 50%;
    width: 100%;
    flex: none;
  }

  .image.column {
    min-height: 40%;
    height: fit-content;
    aspect-ratio: 1/1;
  }

  .content.column {
    height: 50%;
  }

  .content {
    justify-content: flex-start;
  }

  .title {
    font-size: 1.75em;
  }

  .content-inner {
    font-size: 14px;
  }

  .popup-modal:not(.has-image) .content{
    margin-top: 40px;
  }

  .items {
    padding: 0.25rem;
  }

  .item {
    padding: 0.5rem 1.25rem;
  }

}
</style>

{#if visible}
<div id="popup-gallery"></div>

<div class="popup-modal" class:has-image={image ? true : false}>
<div class="popup-area">
  <div class="popup-window-wrap">
    <div class="popup-window" transition:fly={{y: 800, duration: 500 }}>
      <div class="popup-content">
        <div class="popup">
          <CloseButton close={closePopup}/>  

          {#if image}
          <div class="image column" style={`background-image: url(${image});`}>
            <div class="items">
              {#if gallery}<div class="gallery item" on:click={openGallery}><img src="./images/popup_gallery_button.png"/><span>Photos</span></div>{/if}
              {#if videoUrl}<div class="video item" on:click={handleVideoLoad}><img src="./images/popup_video_button.png"/><span>Video</span></div>{/if}
            </div>
          </div>
          {/if}
          
          <div class="content column">
            <!-- <h2 class="title">{@html title}</h2> -->
            <div class="content-inner">
              <h2 class="title">{@html title}</h2>
              {@html content}
              {#if !image}
              <div class="items">
                {#if gallery}<div class="gallery item" on:click={openGallery}><img src="./images/popup_gallery_button.png"/><span>Photos</span></div>{/if}
                {#if videoUrl}<div class="video item" on:click={handleVideoLoad}><img src="./images/popup_video_button.png"/><span>Video</span></div>{/if}
              </div>
              {/if}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="popup-bg" on:click={closePopup} transition:fade={{duration: 500 }}></div>
</div>
</div>
{/if}